<template>
  <div>
    <CameraTestBase
        @stream="onStream"
        @previewVideo="onPreviewVideo"
    ></CameraTestBase>
    <canvas style="position: absolute; left: 0px; top: 0px; pointer-events: none;"
            ref="landmarkCvs"
    ></canvas>

    <div>
      <div>
        <select v-model="grmWebgl.type">
          <option v-for="type in grmWebgl.types" :key="type" :value="type">{{type}}</option>
        </select>
        <button @click="grmMediaStreamTrackGenerator">{{grmWebgl.created ? 'reload' : 'create'}}</button>
        <label class="info"
               v-if="grmWebgl.created"
        ><span>created</span><span>{{grmWebgl.created}}ms</span></label>
      </div>
      <div v-show="grmWebgl.created">
        <div class="layer">
          <label>
            <input type="checkbox" v-model="grmWebgl.mirror">
            <span>mirror</span>
          </label>
          blur: {{grmWebgl.blur}}<input type="range" min="0" max="30" v-model="grmWebgl.blur">
          fps: {{grmWebgl.fps}}<input type="range" min="1" max="60" v-model="grmWebgl.fps">
          <button @click="playCaptureStream">playCaptureStream</button>
        </div>
        <div>
          top-down blurPercent: {{grmWebgl.topDownBlur.percent}}<input type="range" min="0" max="1" step="0.1" v-model="grmWebgl.topDownBlur.percent">
          blurSize: {{grmWebgl.topDownBlur.blurSize}}<input type="range" min="0" max="100" v-model="grmWebgl.topDownBlur.blurSize">
        </div>
        <div>
          <div>
            <label>
              <input type="radio" v-model="grmWebgl.faceDrawType" value="" />
              <span>None</span>
            </label>
            <label>
              <input type="radio" v-model="grmWebgl.faceDrawType" value="box" />
              <span>Box</span>
            </label>
            <label>
              <input type="radio" v-model="grmWebgl.faceDrawType" value="faceImage" />
              <span>Emoji</span>
            </label>
            <label>
              <input type="radio" v-model="grmWebgl.faceDrawType" value="mosaic" />
              <span>Mosaic</span>
            </label>
          </div>
          <div style="pointer-events: none;">
            <img class="emoji" width="50" height="50" style="pointer-events: auto;"
                v-for="emoji in grmWebgl.emojiList" :key="emoji" :src="emoji"
                @click="drawEmogiToFace(emoji)"
            >
          </div>
        </div>
        <div ref="pixiLayer" class="layer">
          <canvas ref="canvas" width="1" height="1"></canvas>
        </div>
        <div v-if="grmWebgl.playCaptureStream" class="layer">
          <div>
            fps: {{grmWebgl.csFps}}<input type="range" min="1" max="60" v-model="grmWebgl.csFps">
          </div>
          <div>
            <video autoplay playsinline crossorigin="anonymous"
                   ref="captureVideo"
            ></video>
          </div>
        </div>
      </div>
      </div>

  </div>
</template>

<script>
import CameraTestBase from "@/components/test/camera/CameraTestBase.vue";
import GrmMediaStreamTrack from "@/lib/gooroomee/track-generator/GrmMediaStreamTrack";
// import GrmMediaStreamTrackGenerator from "@/lib/gooroomee/track-generator/GrmMediaStreamTrackGenerator";

export default {
  name: 'MediaPipeTest',
  components: {CameraTestBase},
  data() {
    return {
      stream: null,
      video: null,
      grmWebgl: {
        types: ['canvas', 'canvasWorker', 'trackGenerator', 'trackGeneratorWorker'],
        type: 'trackGeneratorWorker',
        created: false,
        mirror: false,
        blur: 0,
        fps: 30,
        playCaptureStream: false,
        csFps: 30,
        topDownBlur: {
          direction: 'top-down',
          percent: 0,
          blurSize: 10,
        },
        faceDrawType: 'box',
        emojiList: (() => {
          let list = ['grm-face-01', 'emoti-show-off', 'emoti-angry', 'emoti-fall-love', 'emoti-surprise'].map(name => {
            return require(`@/assets/roomType/lms/img/emoti-img/${name}.svg`);
          });
          list = list.concat(['man-01.png', 'woman-01.png'].map(name => {
            return require(`@/components/test/camera/media-pipe/face-detector/sample/${name}`);
          }));
          return list;
        })()
      }
    }
  },
  watch: Object.assign({},
      (() => {
        const watchList = {};
        [
            'run', 'fps', 'csFps', 'mirror', 'blur', 'faceDrawType',
          'topDownBlur.direction', 'topDownBlur.percent', 'topDownBlur.blurSize'
        ].forEach(key => {
          watchList[`grmWebgl.${key}`] = function(value, old){
            if(!this.grmWebgl || !this.grmWebgl.app) return;
            const app = this.grmWebgl.app;
            switch(key){
              case 'run':
                if(value) app.resume()
                else app.pause()
                break;
              case 'fps':
                app.changeFPS(value);
                break;
              case 'csFps':
                this.playCaptureStream();
                break;
              case 'mirror':
                app.setMirror(value);
                break;
              case 'blur':
                app.setBlur(value);
                break;
              case 'faceDrawType':
                app.setFaceDrawType(value);
                break;
              case 'topDownBlur.direction':
              case 'topDownBlur.percent':
              case 'topDownBlur.blurSize':
                app.setPipeOptions('BlurFilter', {
                  ...this.grmWebgl.topDownBlur
                });
                break;
            }
          }
        });
        return watchList;
      })(),
      (() => {
        const watchList = {};
        ['run', 'detectTermMs'].forEach(key => {
          watchList[`ImageSegment.${key}`] = function(value, old){
            if(!this.grmImageSegmenter || !this.grmImageSegmenter.result) return;
            console.log('change:', `ImageSegment.${key}`)
            const result = this.grmImageSegmenter.result;
            switch(key){
              case 'run':
                if(value) result.resume()
                else result.pause()
                break;
              case 'detectTermMs':
                result.changeDetectIntervalMs(value);
                break;
            }
          }
        })
        return watchList;
      })(),
      (() => {
        const watchList = {};
        ['run', 'worker', 'detectTermMs'].forEach(key => {
          watchList[`SelfieSegmentation.${key}`] = function(value, old){
            if(!this.grmSelfieSegmentation || !this.grmSelfieSegmentation.result) return;
            console.log('change:', `ImageSegment.${key}`)
            const result = this.grmSelfieSegmentation.result;
            switch(key){
              case 'run':
                if(!value){
                  result.destroy();
                }
                break;
              case 'worker':
                this.grmSelfieSegmentation.options.useImageUtilsWorker = value;
                break;
              case 'detectTermMs':
                result.changeDetectIntervalMs(value);
                break;
            }
          }
        })
        return watchList;
      })(),
  ),
  created () {
    window.$vp = this;
    console.log('vue created');

    (() => {
      let wglType = localStorage.getItem('grmWebgl.type');
      if(wglType){
        this.grmWebgl.type = wglType;
      }
    })();
  },
  methods: {
    onStream ({stream}) {
      console.log('# onstream:', stream)
      this.stream = stream;

      if(this.grmWebgl.app){
        const track = stream.getVideoTracks()[0];
        if(!track) return;
        this.grmWebgl.app.replaceVideoMediaStreamTrack(track);
      }
    },
    onPreviewVideo (video) {
      this.video = video;
      video.parentElement.append(this.$refs.landmarkCvs);
    },

    async grmMediaStreamTrackGenerator () {
      let {type} = this.grmWebgl;
      localStorage.setItem('grmWebgl.type', type);

      if(this.grmWebgl.app){
        try{
          this.grmWebgl.app.destroy();
        }catch(e){
          console.error(e);
        }
      }

      let st = Date.now();
      this.grmWebgl.app = GrmMediaStreamTrack.create({
        stream: this.stream,
        // canvas: this.$refs.canvas
      }, {type});
      console.log('# app init');
      await this.grmWebgl.app.init();
      console.log('# app init complete');
      this.grmWebgl.created = Date.now() - st;


      const view = this.grmWebgl.app.getRenderCanvas();
      this.$refs.canvas.replaceWith(view);
      this.$refs.canvas = view;
      this.grmWebgl.app.requestVideoFrameRender();

      if(this.grmWebgl.app?.pipeThrough){
        console.log('# app add pipe');
        this.grmWebgl.app.pipeThrough('BlurFilter', {
          ...this.grmWebgl.topDownBlur
        });
        this.grmWebgl.app.pipeThrough('FaceDetector', {
          drawType: 'box'
        });
      }
    },

    async playCaptureStream () {
      this.grmWebgl.playCaptureStream = true;
      const stream = this.grmWebgl.stream = this.grmWebgl.app.getMediaStream();
      this.grmWebgl.app.applyVideoMediaStreamTrackConstraints({
        frameRate: this.grmWebgl.csFps
      })
      this.$nextTick(() => {
        this.$refs.captureVideo.srcObject = stream;
      });
    },

    async drawEmogiToFace (url) {
      if(!this.grmWebgl.app?.setFaceImage){
        return;
      }

      if(url === this.grmWebgl.emojiUrl){
        return;
      }
      this.grmWebgl.emojiUrl = url;
      this.grmWebgl.app.setFaceImage(url);
    }
  } // end of methods
}
</script>

<style scoped lang="scss">
.emoji {
  display: inline-block;
}
</style>